/** Amber dot + optional count for seller My Items attention (matches mobile bottom nav). */
export function SellerMyItemsAttentionNavIndicator({
  show,
  count,
  compact = false,
}: {
  show: boolean;
  count: number;
  /** Icon overlay (bottom nav) — dot only. */
  compact?: boolean;
}) {
  if (!show) return null;

  if (compact) {
    return (
      <span
        className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-amber-500 ring-2 ring-white"
        aria-hidden
      />
    );
  }

  return (
    <span className="inline-flex shrink-0 items-center gap-1.5" aria-hidden>
      <span className="h-2 w-2 rounded-full bg-amber-500" />
      {count > 0 ? (
        <span className="inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-amber-500 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white">
          {count > 99 ? "99+" : count}
        </span>
      ) : null}
    </span>
  );
}
